import { useSonTranslation } from '../../../../translation/useSonTranslation';
import type { FileDataParam } from '../../types/FileUploadParam';

export function useValidateFileSelection(selection: File[], param: FileDataParam<string>): string[] {
  const { t } = useSonTranslation('FileUpload');

  if (!param.constraints) {
    return [];
  }
  const errors = [];

  const { maxRequestSizeInBytes, maxFileSizeInBytes, minFileSizeInBytes } = param.constraints;

  const requestSizeInBytes = selection.reduce((p, c) => p + c.size, 0);

  if (maxRequestSizeInBytes && requestSizeInBytes > maxRequestSizeInBytes) {
    const maxSizeInMb = Math.round(maxRequestSizeInBytes / (1024 * 1024));
    errors.push(t('validationErrorMessages.maxRequestSizeInBytes', { maxSize: maxSizeInMb }));
  }

  selection.forEach(file => {
    if (maxFileSizeInBytes && maxFileSizeInBytes < file.size) {
      const maxSizeInMb = Math.round(maxFileSizeInBytes / (1024 * 1024));
      const message = t(`validationErrorMessages.maxFileSizeInBytes`, {
        fileName: file.name,
        maxSize: maxSizeInMb,
      });
      errors.push(message);
    }

    if (minFileSizeInBytes && minFileSizeInBytes > file.size) {
      const message = t(`validationErrorMessages.minFileSizeZero`, { fileName: file.name });
      errors.push(message);
    }
  });

  return errors;
}
